<div class="ibox float-e-margins">
	<div class="ibox-content">
		<div class="row" *ngIf="CanSwitchAudience">
			<form class="form-horizontal">
				<div class="form-group">
					<!-- <label class="col-sm-1 col-lg-1 control-label"></label> -->

					<div class="RadioGrid">
						<div>
							<p-radioButton
								name="groupname"
								label="Student"
								(click)="onAudienceSelected($event)"
								value="val1"
								[(ngModel)]="selectedValue"
							></p-radioButton>
						</div>

						<div>
							<p-radioButton
								name="groupname"
								label="Staff"
								(click)="onAudienceSelected($event)"
								value="val2"
								[(ngModel)]="selectedValue"
							></p-radioButton>
						</div>
					</div>
				</div>
			</form>
		</div>

		<div class="Flex">
			<!-- <div [ngClass]="getCSSClasses(false)"> -->
			<div class="FilterClass">
				<caass-personfilterselector
					[InputSchoolID]="InputSchoolID"
					[ShowAllSchools]="ShowAllSchools"
					[AudienceID]="AudienceID"
					[InputApplicationItemID]="InputApplicationItemID"
					[UpdateSchoolSelector]="UpdateSchoolSelector"
				></caass-personfilterselector>
			</div>
			<div [ngClass]="getCSSClasses(true)">
				<!-- <div [ngStyle]="(dialogForm || MultiSelect) ? {height: 300px; overflow-y: scroll} : {}"
         > -->

				<p-table
					*ngIf="!MultiSelect"
					[value]="persons"
					[paginator]="true"
					[(rows)]="pageRows"
					[(first)]="pageFirst"
					[showCurrentPageReport]="true"
					[resizableColumns]="false"
					styleClass="p-datatable-gridlines"
					selectionMode="single"
					[(selection)]="selectedPerson"
					dataKey="PersonID"
					[loading]="loading"
					(onPage)="paginate($event)"
					currentPageReportTemplate="{first} to {last} of {totalRecords} people"
				>
					<ng-template pTemplate="header">
						<tr>
							<th>Last Name</th>
							<th>First Name</th>

							<th>{{ DesignatorLabel }}</th>
							<th>School</th>
							<th *ngIf="AudienceID == 1">Grade</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-person>
						<tr [pSelectableRow]="person" (click)="onRowSelect(person)">
							<td>{{ person.LastName }}</td>
							<td>{{ person.FirstName }}</td>
							<td>{{ person.DesignatorID }}</td>
							<td>{{ person.SchoolNumber }}</td>
							<td *ngIf="AudienceID == 1">{{ person.GradeLevelDesc }}</td>
						</tr>
					</ng-template>
				</p-table>

				<p-table
					*ngIf="MultiSelect"
					[value]="persons"
					(onRowSelect)="onRowSelect($event)"
					(onRowUnselect)="onRowUnselect($event)"
					styleClass="p-datatable-gridlines"
					[(selection)]="selectedPersonsList"
					[scrollable]="true"
					[rows]="100"
					scrollHeight="150px"
					[virtualScroll]="true"
					[virtualRowHeight]="34"
					[loading]="loading"
				>
					<ng-template pTemplate="header">
						<tr [pSelectableRow]="person" (click)="setSelectedMessage(person)">
							<th style="width: 4rem">
								<p-tableHeaderCheckbox (click)="selectRow(e.checked)" #e></p-tableHeaderCheckbox>
							</th>
							<th>Last Name</th>
							<th>First Name</th>
							<th>{{ DesignatorLabel }}</th>
							<th>School</th>
							<th *ngIf="AudienceID == 1">Grade Level</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-person>
						<tr [pSelectableRow]="person" (click)="setSelectedMessage(person)">
							<td style="width: 4rem">
								<p-tableCheckbox [pSelectableRow]="person" [value]="person"></p-tableCheckbox>
							</td>
							<td>{{ person.LastName }}</td>
							<td>{{ person.FirstName }}</td>
							<td>{{ person.DesignatorID }}</td>
							<td>{{ person.SchoolNumber }}</td>
							<td *ngIf="AudienceID == 1">{{ person.GradeLevelDesc }}</td>
						</tr>
					</ng-template>
				</p-table>

				<!--   <table
            class="table table-striped table-bordered table-hover"
            my-table
            options="options"
            width="100%"
            id="myPersonListTable"
          >
            <thead>
              <tr>
                <th [style.display]="getCheckBoxDisplay()"></th>
                <th>{{ NameLabel }}</th>
                <th>{{ DesignatorLabel }}</th>
                <th>School</th>
              </tr>
            </thead>
            <tbody></tbody>
          </table> -->

				<div style="margin-top: 10px" *ngIf="dialogForm || MultiSelect">
					<!-- <button
            type="button"
            (click)="selectAll('check')"
            class="btn-xs btn-primary"
          >
            Select all
          </button>
          <button
            type="button"
            (click)="selectAll('uncheck')"
            class="btn-xs btn-primary"
          >
            UnSelect all
          </button> -->

					<button *ngIf="ShowProcessButton" type="button" (click)="ProcessSelectedMultiplePersons()" class="btn-xs btn-primary">
						{{ buttonMultiSelectProcessCaption }}
					</button>
					<span>{{ selectedMessage }}</span>
				</div>
			</div>
			<div class="col-sm-12 col-lg-12 alert alert-danger" *ngIf="(dialogForm || MultiSelect) && errorMessage">
				{{ errorMessage }}
			</div>

			<div *ngIf="!dialogForm && selectedPerson">
				<div class="contact-box" style="text-align: center" [style.background-color]="selectedPerson.IsSuspensed == true ? '#ff26269e' : '#ffffff'">
					<img
						*ngIf="PersonLoading == false && PersonPhotoLoading == false && selectedPerson.PersonPhotoUrl"
						alt="image"
						style="cursor: pointer"
						alt="Click to edit"
						(click)="photoClick(selectedPerson?.PersonID)"
						[src]="selectedPerson.PersonPhotoUrl"
						class="IMGClass"
					/>

					<div *ngIf="PersonLoading == true || PersonPhotoLoading == true" class="SpinnerDiv">
						<p-progressSpinner></p-progressSpinner>
					</div>

					<div
						*ngIf="selectedPerson != undefined && this.selectedPerson.PersonID > 0 && PersonLoading == false && PersonPhotoLoading == false"
						class="text-center"
						(change)="changePerson(selectedPerson?.PersonID)"
					>
						<h3 style="margin-bottom: 5px">
							<strong style="font-size: 12px">{{ selectedPerson?.PersonName }}</strong>
						</h3>

						<p
							ng-hide="person.Active"
							[ngClass]="{
								alert: true,
								'alert-success': selectedPerson.Active == true,
								'alert-warning': selectedPerson.Active == false,
								NoPadding: true
							}"
							style="margin-bottom: 3px"
						>
							{{ selectedPerson.Active == true ? "Active" : "Inactive" }}
						</p>

						<p
							*ngIf="AudienceID != 2"
							ng-hide="person.AttendanceStatusDesc"
							[ngClass]="{
								alert: true,
								'alert-success': selectedPerson.AttendanceStatusDesc == 'Present & On time',
								'alert-warning': selectedPerson.AttendanceStatusDesc == 'Tardy' || selectedPersonAttendanceStatusDesc == 'Partial Present',
								'alert-info': selectedPerson.AttendanceStatusDesc == 'School Closed',
								'alert-danger':
									selectedPerson.AttendanceStatusDesc != 'Present & On time' &&
									selectedPerson.AttendanceStatusDesc != 'Tardy' &&
									selectedPerson.AttendanceStatusDesc != 'Partial Present' &&
									selectedPerson.AttendanceStatusDesc != 'School Closed',
								NoPadding: true
							}"
							style="margin-bottom: 3px"
						>
							{{ selectedPerson?.AttendanceStatusDesc }}
						</p>

						<p
							*ngIf="AudienceID != 2 && selectedPerson?.HasEntry == true"
							ng-hide="person.HasEntry"
							class="alert alert-info NoPadding"
							style="margin-bottom: 3px"
						>
							Entry Time: {{ selectedPerson?.EntryDTDesc }}
						</p>

						<p
							*ngIf="AudienceID != 2 && selectedPerson?.HasExit == true"
							ng-hide="person.HasExit"
							class="alert alert-info NoPadding"
							style="margin-bottom: 0px"
						>
							Exit Time: {{ selectedPerson?.ExitDTDesc }}
						</p>

						<!-- <p *ngIf="person.SuspensionStatusDesc != 'Not Suspended'" 
              [ngClass]="
              { 
                'alert' : true,
                'alert-success' : selectedPerson.SuspensionStatusDesc == 'Not Suspended',
                'alert-danger' : selectedPerson.SuspensionStatusDesc != 'Not Suspended',
                'NoPadding': true
              }"
              style="margin-bottom: 10px;">
              
              {{ selectedPerson?.SuspensionStatusDesc }}
            </p> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
